import { render } from "./form-generated-string.vue?vue&type=template&id=9bb8d360"
import script from "./form-generated-string.vue?vue&type=script&lang=js"
export * from "./form-generated-string.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__